<script setup lang="ts">
import {Backing} from "@/backing/interfaces/backing";
import {Euro} from "@lucide/vue";
import BackingService from "@/backing/services/BackingService";

defineProps<{
    backing: Backing
}>();
</script>

<template>
  <div class="flex items-center gap-1 pr-3">
    <Euro />
    <p>N'oubliez pas de facturer le code acte <strong>{{ BackingService.actCode(backing) }}</strong></p>
  </div>
</template>
